<template>
    <!-- 订单管理-积分订单管理-优惠券订单详情 -->
    <content-view>
        <template slot="header">
            <div class="pt24 pb24">
                <span style="cursor: pointer;" @click="$router.back();"><a-icon class="mr8" type="left" />返回订单列表</span>
            </div>
        </template>
        <div class="retail-order-detail wrap-container-in">
            <a-spin :spinning="spinning">
                <div class="font-weight font-big">用户信息</div>
                <a-row class="mt24">
                    <a-col :span="6">会员昵称：{{orderDetail.account}}</a-col>
                    <a-col :span="6">会员手机号：{{orderDetail.phone}}</a-col>
                </a-row>
                <a-divider></a-divider>
                <div class="font-weight font-big">交易信息</div>
                <a-row class="mt24">
                    <a-col :span="7">交易订单号：{{orderDetail.transNo}}</a-col>
                    <a-col :span="7">下单时间：{{orderDetail.orderTime}}</a-col>
                    <a-col :span="7">支付时间：{{orderDetail.payTime | isEmpty}}</a-col>
                </a-row>
                <a-row class="mt24">
                    <a-col :span="7">交易状态：{{orderDetail.transStateStr}}</a-col>
                    <a-col :span="7">应收积分：{{orderDetail.orderPoint | thousandFormat}}</a-col>
                    <a-col :span="7">实收积分：{{orderDetail.payPoint | thousandFormat}}</a-col>
                </a-row>
                <a-divider></a-divider>
                <div class="font-weight font-big mb24">优惠券信息</div>
                <a-table bordered :dataSource="orderDetail.coupons" :columns="columns" :pagination="false" :rowKey="(record, index) => index">
                    <template slot="isEmpty" slot-scope="key, row">{{key | isEmpty}}</template>
                    <template slot="thousandFormat" slot-scope="key, row">{{key | thousandFormat}}</template>
                    <template slot="couponType" slot-scope="key, row">{{key | couponType}}</template>
                    <template slot="effectTime" slot-scope="key, row">{{key | isEmpty}} ~ {{row.expireTime | isEmpty}}</template>
                    </a-table>
            </a-spin>
        </div>
    </content-view>
</template>

<script type="text/javascript">
    const columns = [
        {
            title: "用户优惠券号",
            dataIndex: "businessId"
        },
        {
            title: "优惠券商城展示名称",
            dataIndex: "showName"
        },
        {
            title: "优惠券名称",
            dataIndex: "goodsName"
        },
        {
            title: "商品积分",
            dataIndex: "beforeDiscountPoint",
            scopedSlots: { customRender: "thousandFormat" }
        },
        {
            title: "优惠券类型",
            dataIndex: "type",
            scopedSlots: { customRender: "couponType" }
        },
        {
            title: "优惠券状态",
            dataIndex: "stateStr",
            scopedSlots: { customRender: "isEmpty" }
        },
        {
            title: "有效期",
            dataIndex: "effectTime",
            scopedSlots: { customRender: "effectTime" }
        },

    ];
    export default {
        name: "pointOrderDetailCoupon",
        components: {
        },
        props: {},
        data() {
            return {
                columns,
                orderDetail: {
                    coupons: []
                },
                spinning: true
            };
        },

        computed: {
        },
        methods: {
            /**
             * @func getDetial 获取订单详情
             */
            getDetial() {
                let transNo = this.$route.params.tradeNo;
                if (!Boolean(transNo)) {
                    this.$router.back();
                    return false;
                }
                this.$api.order.viewTrade({
                    body: {
                        transNo,
                        source: 'COUPON',
                        transStateStr: this.$route.query.transStateStr || null
                    }
                }).then(res => {
                    this.spinning = false;
                    if (!Boolean(res.coupons)) {
                        res.coupons = [];
                    }
                    this.orderDetail = res;
                })
            }
        },
        created() {},
        mounted() {
            this.getDetial();
        },
        watch: {
        },
        beforeCreate() {
        }
    };
</script>

<style lang="scss">

</style>
